// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".s-module__helper--q40rT {\n  font-size: 13px;\n  color: var(--gray-500);\n  line-height: 1.5;\n  margin: 0;\n}\n", "",{"version":3,"sources":["webpack://./src/pages/InsuranceBillingOnboarding/steps/StepTaxInfo/s.module.less"],"names":[],"mappings":"AACA;EACI,eAAA;EACA,sBAAA;EACA,gBAAA;EACA,SAAA;AAAJ","sourcesContent":["// Step 2 — Tax information 私有样式：SSN 帮助文案（原型 .ibbw-helper）\n.helper {\n    font-size: 13px;\n    color: var(--gray-500);\n    line-height: 1.5;\n    margin: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"helper": "s-module__helper--q40rT"
};
export default ___CSS_LOADER_EXPORT___;
